import {kaspiPOSService} from "../services/kaspiPosService";
import {useEffect, useState} from "react";

const KaspiPOSTestPage = () => {
    const [amount, setAmount] = useState('');
    const [transactionId, setTransactionId] = useState('');
    const [method, setMethod] = useState('');
    const [status, setStatus] = useState('');
    const [isProcessing, setIsProcessing] = useState(false);
    const [currentProcessId, setCurrentProcessId] = useState('');
    const [isInitialized, setIsInitialized] = useState(false);
    const [transactionData, setTransactionData] = useState(null);


    // Проверяем инициализацию при загрузке компонента
    useEffect(() => {
        const checkInitialization = async () => {
            if (kaspiPOSService.checkDeviceAuthorization()) {
                const initialized = await kaspiPOSService.init();
                setIsInitialized(initialized);
                if (!initialized) {
                    setStatus('Устройство не авторизовано или Kaspi POS не настроен');
                }
            } else {
                setStatus('Устройство не авторизовано');
            }
        };

        checkInitialization();
    }, []);

    const handlePayment = async () => {
        if (!amount || isProcessing || !isInitialized) return;

        setIsProcessing(true);
        setStatus('Начинаем оплату...');

        try {
            const result = await kaspiPOSService.startPayment(parseInt(amount), true);
            const customMessages = this.getCustomStatusMessages();

            if (result.success) {
                setCurrentProcessId(result.processId);
                setStatus('Оплата началась, ожидаем завершения...');

                const finalResult = await kaspiPOSService.monitorTransaction(result.processId, (statusUpdate) => {
                    setStatus(customMessages[statusUpdate.subStatus]);
                });

                if (finalResult.success) {
                    if (finalResult.status === 'success') {
                        setStatus('Оплата успешна!');
                        setTransactionData(finalResult); // Сохраняем данные транзакции
                    } else {
                        setStatus(`Оплата неуспешна: ${finalResult.message || 'Неизвестная ошибка'}`);
                    }
                } else {
                    setStatus(`Ошибка мониторинга: ${finalResult.error}`);
                }
            } else {
                setStatus(`Ошибка старта оплаты: ${result.error}`);
            }
        } catch (error) {
            setStatus(`Ошибка: ${error.message}`);
        } finally {
            setIsProcessing(false);
            setCurrentProcessId('');
        }
    };

    const handleRefund = async () => {
        if (!amount || !transactionData || isProcessing || !isInitialized) return;

        setIsProcessing(true);
        setStatus('Начинаем возврат...');

        try {
            const result = await kaspiPOSService.startRefund(parseInt(amount), transactionData, true);
            const customMessages = this.getCustomStatusMessages();

            if (result.success) {
                setCurrentProcessId(result.processId);
                setStatus('Возврат начался, ожидаем завершения...');

                const finalResult = await kaspiPOSService.monitorTransaction(result.processId, (statusUpdate) => {
                    setStatus(customMessages[statusUpdate.subStatus]);
                });

                if (finalResult.success) {
                    if (finalResult.status === 'success') {
                        setStatus('Возврат успешен!');
                    } else {
                        setStatus(`Возврат неуспешен: ${finalResult.message || 'Неизвестная ошибка'}`);
                    }
                } else {
                    setStatus(`Ошибка мониторинга: ${finalResult.error}`);
                }
            } else {
                setStatus(`Ошибка старта возврата: ${result.error}`);
            }
        } catch (error) {
            setStatus(`Ошибка: ${error.message}`);
        } finally {
            setIsProcessing(false);
            setCurrentProcessId('');
        }
    };

    if (!isInitialized) {
        return (
            <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
                <h2>Kaspi POS Test Page</h2>
                <div style={{
                    padding: '20px',
                    backgroundColor: '#fff3cd',
                    borderRadius: '4px',
                    marginTop: '20px',
                    border: '1px solid #ffeaa7'
                }}>
                    <strong>Предупреждение:</strong> {status || 'Kaspi POS не инициализирован'}
                </div>
            </div>
        );
    }

    return (
        <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
            <h2>Kaspi POS Test Page</h2>

            <div style={{ marginBottom: '20px' }}>
                <label>Сумма: </label>
                <input
                    type="number"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    disabled={isProcessing}
                    style={{ margin: '0 10px', padding: '5px' }}
                />
            </div>

            <div style={{ marginBottom: '20px' }}>
                <label>JSON транзакции для возврата: </label>
                <input
                    type="text"
                    value={transactionData}
                    onChange={(e) => setTransactionData(e.target.value)}
                    disabled={isProcessing}
                    style={{ margin: '0 10px', padding: '5px', width: '200px' }}
                />
            </div>

            {transactionData && (
                <div style={{ marginBottom: '20px' }}>
                    <label>Данные транзакции: </label>
                    <div style={{
                        padding: '10px',
                        backgroundColor: '#f9f9f9',
                        borderRadius: '4px',
                        fontSize: '0.9em'
                    }}>
                        Метод: {transactionData.chequeInfo?.method},
                        ID: {transactionData.chequeInfo?.method === 'qr' ?
                        transactionData.chequeInfo?.orderNumber :
                        transactionData.chequeInfo?.rrn}
                    </div>
                </div>
            )}

            <div style={{ marginBottom: '20px' }}>
                <label>Метод оплаты: </label>
                <select
                    value={method}
                    onChange={(e) => setMethod(e.target.value)}
                    disabled={isProcessing}
                    style={{ margin: '0 10px', padding: '5px' }}
                >
                    <option value="qr">QR</option>
                    <option value="card">Карта</option>
                </select>
            </div>

            <div style={{ marginBottom: '20px' }}>
                <button
                    onClick={handlePayment}
                    disabled={isProcessing || !amount}
                    style={{
                        padding: '10px 20px',
                        marginRight: '10px',
                        backgroundColor: isProcessing ? '#ccc' : '#4CAF50',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: isProcessing ? 'not-allowed' : 'pointer'
                    }}
                >
                    {isProcessing ? 'Обработка...' : 'Оплата'}
                </button>

                <button
                    onClick={handleRefund}
                    disabled={isProcessing || !amount || !transactionData}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: isProcessing || !transactionData ? '#ccc' : '#f44336',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: isProcessing || !transactionData ? 'not-allowed' : 'pointer'
                    }}
                >
                    {isProcessing ? 'Обработка...' : 'Возврат'}
                </button>
            </div>

            {status && (
                <div style={{
                    padding: '10px',
                    backgroundColor: '#f0f0f0',
                    borderRadius: '4px',
                    marginTop: '20px'
                }}>
                    <strong>Статус:</strong> {status}
                    {currentProcessId && (
                        <div style={{ marginTop: '5px', fontSize: '0.9em', color: '#666' }}>
                            Process ID: {currentProcessId}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default KaspiPOSTestPage